import { useTranslation } from 'react-i18next';
import useBgPages from '../../hooks/use-bg-pages.hook';
import ChannelOrTemplatePanel from '../../components/cards/panel.component';
import { useSession } from '../../hooks/use-session.hook';

const TemplatesPannel: React.FC = () => {
  useBgPages();
  const { t } = useTranslation();
  const { session, selectedAccount, accounts } = useSession();
  const hasChannel = (channelKey: string) => {
    const currentAccount = accounts
      ?.flat()
      ?.find(({ account }: any) => account._id === selectedAccount?.account_id);
    const channelArray = currentAccount?.account?.channels?.[channelKey];
    return Array.isArray(channelArray) && channelArray.some((ch) => ch.status === true);
  };

  const shouldFilterChannels = session?.profile === 'ADMIN';

  const templates = [
    (!shouldFilterChannels || hasChannel('whatsapp')) && {
      to: '/channels-panel/channels-wa',
      type: 'Canal',
      title: 'WhatsApp',
      description: t('channels.c1'),
      logoSrc: '/assets/media/logos/meta.png',
      imageHeader: true,
      srcImage: 'c-wa'
    },
    (!shouldFilterChannels || hasChannel('sms')) && {
      to: '/channels-panel/channels-sms',
      type: 'Canal',
      title: 'SMS',
      description: t('channels.c2'),
      logoSrc: '/assets/media/logos/sms-logo.png',
      imageHeader: true,
      srcImage: 'c-sms'
    },
    (!shouldFilterChannels ||
      hasChannel('rcs_basic') ||
      hasChannel('rcs_single') ||
      hasChannel('rcs_conversational')) && {
      to: '/channels-panel/channels-rcs',
      type: 'Canal',
      title: 'RCS',
      description: t('channels.c3'),
      logoSrc: '/assets/media/logos/rcs-logo.png',
      imageHeader: true,
      srcImage: 'c-rcs'
    },
    (!shouldFilterChannels || hasChannel('mailing')) && {
      to: '/channels-panel/channels-mailing',
      type: 'Canal',
      title: 'Correo',
      description: t('channels.c4'),
      logoSrc: '/assets/media/logos/mail-logo.webp',
      imageHeader: true,
      srcImage: 'c-email'
    }
  ].filter(Boolean);

  const links = [
    (!shouldFilterChannels || hasChannel('whatsapp')) && {
      to: '/channels-panel/channels-wa',
      label: 'WhatsApp',
      icon: 'ki-whatsapp'
    },
    (!shouldFilterChannels || hasChannel('sms')) && {
      to: '/channels-panel/channels-sms',
      label: 'SMS',
      icon: 'ki-messages'
    },
    (!shouldFilterChannels ||
      hasChannel('rcs_basic') ||
      hasChannel('rcs_single') ||
      hasChannel('rcs_conversational')) && {
      to: '/channels-panel/channels-rcs',
      label: 'RCS',
      icon: 'ki-messages'
    },
    (!shouldFilterChannels || hasChannel('mailing')) && {
      to: '/channels-panel/channels-mailing',
      label: 'Mail',
      icon: 'ki-mail'
    }
  ].filter(Boolean);

  return (
    <ChannelOrTemplatePanel
      title={t('channels.title')}
      subtitle={
        <p className="fs-6 text-dark flex-grow-1 pe-4 pt-4">
          {t('channels.subtitlep1')} <br /> {t('channels.subtitlep2')}
        </p>
      }
      items={templates as any}
      links={links as any}
    />
  );
};

export default TemplatesPannel;
